import { useState, useEffect } from "react";
import _ from "lodash";
import {
  canUserEditEventForAll,
  canUserCreateEventOnCalendar,
  canUserEditEventForProgram,
} from "MyCalendar/modules/Utils";
import { isCalendarEventWithinUserScope } from "MyCalendar/modules/MyCalendarModule";

const useIsCalendarInUserScope = ({
  isStaff,
  userId,
  eventData,
  organizationId,
  academicYearId,
  currentCurriculumProgramId,
  isStaffSchoolCalendarAdmin,
  courseList,
  organizationCurriculumPrograms,
}) => {
  const [queryState, setQueryState] = useState({
    isLoading: isStaff,
    isVisible: false,
  });

  const eventId = _.get(eventData, "id");
  useEffect(() => {
    setQueryState({
      isLoading: true,
      isVisible: false,
    });
  }, [eventId]);

  useEffect(() => {
    if (!isStaff) {
      setQueryState({
        isLoading: false,
        isVisible: false,
      });
      return;
    }

    // reset state initially
    let isCleanedUp = false;

    const canPublishToAll = canUserEditEventForAll({
      currentCurriculumProgramId,
    });

    if (canPublishToAll) {
      setQueryState({
        isLoading: false,
        isVisible: true,
      });
      return;
    }
    const canCreateAnnouncement = canUserCreateEventOnCalendar({
      isStaffSchoolCalendarAdmin,
      currentCurriculumProgramId,
      courseList,
    });
    const canPublishToProgram = canUserEditEventForProgram({
      currentCurriculumProgramId,
    });
    const isOnlyViewPermission = !canCreateAnnouncement;
    if (isOnlyViewPermission) {
      setQueryState({
        isLoading: false,
        isVisible: false,
      });
      return;
    }

    const isCreatedByMe = _.get(eventData, "item.createdBy.id") === userId;
    const associatedEntities = _.get(eventData, "item.associatedEntities", []);

    if (!canPublishToProgram) {
      // User has a teacher role, and event is not originally created by him
      // -- or the event cohort entity is of Course Entity for the created Event
      if (
        !isCreatedByMe ||
        _.get(_.first(associatedEntities), "__typename") === "Grade"
      ) {
        setQueryState({
          isLoading: false,
          isVisible: false,
        });
        return;
      }
    }

    const getAllowEditByComparingScope = async () => {
      const isInScope = await isCalendarEventWithinUserScope({
        userId,
        eventData,
        organizationId,
        currentCurriculumProgramId,
        academicYearId,
        organizationCurriculumPrograms,
      });
      if (isCleanedUp) return;
      setQueryState({
        isLoading: false,
        isVisible: isInScope,
      });
    };
    getAllowEditByComparingScope();

    return () => {
      isCleanedUp = true;
    };
  }, [
    eventData,
    isStaff,
    userId,
    organizationId,
    currentCurriculumProgramId,
    academicYearId,
  ]);

  return queryState;
};

export default useIsCalendarInUserScope;
